import { Box, Checkbox } from "@mui/material"
import { SelectUserProps, SelectUserRef } from "./type"
import { ModelThree } from "../../../../../reportFolio/pages/dashboard/components/details"
// import { NoResponse } from "../../../../../../components/errors/noResponse"
// import { useTranslation } from "react-i18next"
import { useStyles } from "./styles"
import { Ref, forwardRef, useImperativeHandle } from "react"
import { Item } from "../../../../../../utils/types/generals"

const SelectUser = forwardRef(({ list, userSelecteds, setUserSelecteds }: SelectUserProps, ref: Ref<SelectUserRef>) => {
    // const { t } = useTranslation()
    const styles = useStyles()
    const selectUser = ({ user }: { user:Item }) => {
        if (user?.id) {
            if (userSelecteds.some(selected => selected.value == user.id)) {
                setUserSelecteds(prev => prev.filter(selected => selected.id != user.id))
                return
            }
            setUserSelecteds(prev => ([...prev, user]))
            return
        }
    }
    useImperativeHandle(ref, () => ({
        getData: () => userSelecteds,
        getUserList: () => {
            const users = list.filter(user => user.id && userSelecteds.some(selected => selected.id == user.id))

            return users
        }
    }))
    return (
        <Box sx={styles.container}>
            {
                list.map(user => (
                    <Box sx={styles.userContent} key={user.id}>
                        <Checkbox
                            checked={userSelecteds.some((selected) => selected.id == user?.id)}
                            onClick={() => { selectUser({ user }) }}
                        />

                        <ModelThree title={user.label} description={user.role} date={''} />
                    </Box>
                ))
            }

            {/* {!list?.length && <NoResponse label={t('actionPlan.noAprovers')} />} */}
        </Box>
    )
})
export default SelectUser